import { ReviewsList } from 'components/reviews/ReviewsList/ReviewsList'

export const Reviews: React.FC = () => {
  return <ReviewsList />
}
